import React, { useEffect, useMemo, useState, useRef } from 'react';
import { EditTable } from '@components';
import { getOrgGridColumns } from '@model/sectionWidget.model';
import actions from '@flux/action';
import { useDispatch } from 'react-redux';
import { OrgChartGrid } from '@components';
import alert from '@components/alert';

export default function OrgGrid({
  editTableRef,
  isEditMode,
  sourceData,
  handleSave,
  toggleEdit,
  link,
  afterCancel,
}) {
  const dispatch = useDispatch();
  const [edittingTableDataSource, setEdittingTableDataSource] =
    useState(sourceData);
  const [shouldAddOrgRow, setShouldAddOrgRow] = useState(true);
  const sourceDataRef = useRef(sourceData);

  const onDataChange = (data) => {
    if (!Array.isArray(data)) {
      return;
    }

    setShouldAddOrgRow(data.length === 0);
    sourceDataRef.current = data;
  };

  const orgHandleSave = (data) => {
    dispatch(actions.changeWidget({ widgetId: link, data: {} }));
    handleSave(data);
  };

  useEffect(() => onDataChange(sourceData), [sourceData]);

  const editTableParams = useMemo(
    () => ({
      isEditMode,
      edittingTableDataSource,
      setEdittingTableDataSource,
      tableProps: {
        pagination: false,
        rowKey: 'id',
      },
      tableColumns: getOrgGridColumns().filter((item) =>
        isEditMode ? true : item.dataIndex !== 'hierachy',
      ),
      defaultDataSource: sourceData,
      dataChange: onDataChange,
      afterAddRowFunc: (newItem) => {
        newItem.type = shouldAddOrgRow ? 'Organization' : 'Individual';
        newItem.name = shouldAddOrgRow ? 'Board' : '';
        newItem.title = shouldAddOrgRow ? 'Board' : '';
        if (shouldAddOrgRow) {
          newItem.hierachy = 0;
        }
      },
      afterCancel: () => {
        sourceDataRef.current = sourceData;
        if (sourceData.length === 0) {
          setShouldAddOrgRow(true);
        }
        if (typeof afterCancel === 'function') {
          afterCancel();
        }
      },
      saveData: orgHandleSave,
      toggleEdit,
    }),
    [isEditMode, sourceData, shouldAddOrgRow],
  );

  return <OrgChartGrid ref={editTableRef} {...editTableParams} />;
}
